<template>
  <app-launcher-warning
    :app-state="appState"
    :app-error="appError"
    :v-suggest="vSuggest"
    :v-target="updateTargetVersion"
    :is-updating="isPreparingInstall"
    :is-loading="isSavingSettings"
    :is-user-an-admin="isUserAdmin"
    @app-install="onUpdateToMaxAppVersion"
    @app-update="onUpdateToMaxAppVersion"
    @accept-version="onAcceptVersion"
    @retry-update="onRetryAppUpdate"
    @update="onUpdateToTargetAppVersion"
    @cancel="onClearChanges"
    @go-to-launcher="onGoToAppLauncher"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue-demi';

import AppLauncherWarning from '../components/AppLauncherWarning.vue';
import { useAppLauncher, useCommonActions, useAppUpdate, useAppLauncherRouting } from '../composables';

export default defineComponent({
  name: 'AppLauncherWarningContainer',
  components: { AppLauncherWarning },
  setup() {
    const {
      appState,
      appError,
      updateTargetVersion,
      vSuggest,
      isPreparingInstall,
      isSavingSettings,
      isUserAdmin,
    } = useAppLauncher();
    const { onUpdateToMaxAppVersion, onRetryAppUpdate, onUpdateToTargetAppVersion } = useAppUpdate();
    const { onAcceptVersion, onClearChanges } = useCommonActions();
    const { goToAppLauncher } = useAppLauncherRouting();

    const onGoToAppLauncher = () => goToAppLauncher({ skipInitialization: true });

    return {
      appState,
      appError,
      updateTargetVersion,
      vSuggest,
      isPreparingInstall,
      isSavingSettings,
      isUserAdmin,
      onAcceptVersion,
      onUpdateToMaxAppVersion,
      onRetryAppUpdate,
      onUpdateToTargetAppVersion,
      onClearChanges,
      onGoToAppLauncher,
    };
  },
});
</script>
